import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV,
    faTable,
    faCaretUp,
    faCaretDown
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Chart as ChartJS } from 'chart.js/auto';
import { Line } from 'react-chartjs-2'
import { apiRentalsAnalysisChart } from '../../services/apis/retail/apiRentalsAnalysisChart';

class RentalsAnalysisChart extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tooltipClassname: null,
            tooltipArrow: faCaretUp,
            tooltipArrowDisplay: 'none',
            tooltipYLabel: null,
            tooltipxLabel: null,
            chartOtions: {},
            chartData: {
                labels: [],
                datasets: []
            }
        }
    }

    componentDidMount() {
        const ctx = document.getElementById('rentalsVacancyLineChart').getContext("2d");
        let gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, 'rgba(113,206,250, 1)');
        gradient.addColorStop(1, '#cce9ff');

        const superClass = this;
        const options = {
            responsive: true,
            scales: {
                x: {
                    grid: {
                        display: false
                    }
                },
                y: {
                    // ticks: {
                    //     display: false
                    // },
                    grid: {
                        display: true,
                        drawBorder: true
                    }
                }
            },
            plugins: {
                legend: {
                    display: false,
                    // position: 'top',
                },
                title: {
                    display: false,
                    // text: 'Chart.js Bar Chart',
                },
                tooltip: {
                    enabled: false,
                    y: "bottom",
                    backgroundColor: '#FFFFFF',
                    external: function (context) {
                        if ((typeof context.tooltip.dataPoints[0].parsed.y !== 'undefined' && context.tooltip.dataPoints[0].parsed.y !== superClass.state.tooltipYLabel) || (typeof context.tooltip.dataPoints[0].label !== 'undefined' && context.tooltip.dataPoints[0].label !== superClass.state.tooltipxLabel)) {
                            superClass.setState({
                                tooltipClassname: 'colorRed',
                                tooltipArrow: faCaretDown,
                                tooltipArrowDisplay: '',
                                tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                                tooltipxLabel: context.tooltip.dataPoints[0].label
                            });
                        }
                    },
                }
            }
        };

        apiRentalsAnalysisChart.get().then((res) => {
            // this.setState({ officeDemandSupply: res.data });
            let data = {
                labels: res.data.x,
                datasets: [
                    {
                        // label: 'bar1',
                        data: res.data.datapoints.y1,
                        // fill: true,
                        // backgroundColor: gradient,
                        borderColor: "rgba(76, 143, 234, 1)",
                        // lineTension: 0.4
                    },
                    {
                        // label: 'bar2',
                        data: res.data.datapoints.y2,
                        // fill: true,
                        // backgroundColor: gradient,
                        borderColor: "rgba(224,224,224, 1)",
                        // lineTension: 0.4
                    }
                ]
            };

            superClass.setState({
                chartOtions: options,
                chartData: data
            });
        });


    }

    render() {
        return (
            <div className="col-lg-6">
                <div className="widget widgetGraph">
                    <div className="row">
                        <div className="col-lg-9 text-start colorLightBlue">
                            <p>Rentals Analysis</p>
                            <h4 className={this.state.tooltipClassname}>
                                <FontAwesomeIcon icon={this.state.tooltipArrow} style={{ display: this.state.tooltipArrowDisplay }} />
                                {this.state.tooltipYLabel} &nbsp;
                            </h4>
                            <p className="colorBlack pSmall">{this.state.tooltipxLabel}&nbsp;</p>
                        </div>
                        <div className="col-lg-3 text-end">
                            <Link to="/#">
                                <FontAwesomeIcon icon={faTable} />
                            </Link>
                            <Link to="/#" className="colorBlack">
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </Link>
                        </div>
                        <div className="col-lg-12"><Line id='rentalsVacancyLineChart' options={this.state.chartOtions} data={this.state.chartData} /></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RentalsAnalysisChart;
